import Axios from "../../../axios.js";
import {bellMusicApiConstants} from "../../../constants/ApiConstant";

// Bell music (Music Library) backend calls. The stored `url` is a MinIO object
// key; search responses come back with a resolved presigned URL that can be
// played directly.

export async function searchBellMusic(params, page = 1, size = 100) {
    return Axios.post(`${bellMusicApiConstants.SEARCH_BELL_MUSIC}?page=${page}&size=${size}`, params);
}

export async function saveBellMusic(params) {
    return Axios.post(bellMusicApiConstants.SAVE_BELL_MUSIC, params);
}

export async function deleteBellMusic(params) {
    return Axios.post(bellMusicApiConstants.DELETE_BELL_MUSIC, params);
}
